// extracted by mini-css-extract-plugin
export default {"property":"certificate_tile-module___property___d8cedc3f"};